<template>
<div>

    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="blue darken-3" dark app fixed>
        <v-toolbar-title :style="longSearch()" class="ml-0">
            <v-toolbar-side-icon @click.stop="drawerOpenClose()"></v-toolbar-side-icon>
            <span class="hidden-sm-and-down"><a href="/" style ="color: white; text-decoration: none;">Yugpartner</a></span>
        </v-toolbar-title>
        <v-text-field @keyup.enter="searchIn()" v-model="searchStr" flat solo-inverted hide-details prepend-inner-icon="search" label="Пошук" class=""></v-text-field>

        <v-spacer></v-spacer>
        <span class="hidden-sm-and-down">{{userInfo().name}}</span>
        <v-btn icon @click="logout()">
            <v-icon>logout</v-icon>
        </v-btn>

    </v-toolbar>
    <NavigationDrawer />
</div>
</template>


<script>
import {
    HTTP
} from '../http-common'

import NavigationDrawer from '@/components/NavigationDrawer.vue'
import {mapGetters} from 'vuex'

export default {

    components: {
        NavigationDrawer
    },
    data: () => ({
        error: [],
        searchStr: ''
    }),
    props: {},
    methods: {
        ...mapGetters(['userInfo']),
        searchIn() {
            if (this.searchStr) {
                this.$router.push('/?query=' + encodeURIComponent(this.searchStr))
            }
        },
        longSearch(){
            return screen.width < 500 ? 'width: 70px' : 'width: 300px'
        },
        drawerOpenClose() {
            this.$store.commit('openCloseNavigationDrawer', !this.$store.state.main.navigationDrawerOpened);
        },
        logout: function (params) {
            HTTP.delete('/auth/logout')
                .then(response => {
                    this.$router.push({
                        name: 'login'
                    })
                })
                .catch(e => {
                    this.error.push(e)
                })
                .finally(
                    () => {
                        this.show = true
                    }
                )

        }
    },
}
</script>
